import menu from './menu.js';
import user from './user.js';
import common from './common.js';

export default {
    menu,
    user,
    common
}
